import { Card, CardContent, Typography, Box } from "@mui/material";
import { Shipment } from "../types/types";

export const ShipmentHistory = ({ shipments }: { shipments: Shipment[] }) => {
  if (shipments.length === 0) return <Typography textAlign={"center"}>No shipments yet</Typography>;

  return (
    <Card sx={{ mb: 3, mt:3}}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Shipment History
        </Typography>
        {shipments.map((shipment) => (
          <Box key={shipment.id} mb={2} p={2} border={1} borderRadius={2}>
            <Typography variant="subtitle1">
              Shipment #{shipment.id} - {shipment.tracking_number}
            </Typography>
            <Typography variant="body2">
              Carrier: {shipment.carrier || 'N/A'} | 
              Shipped: {new Date(shipment.shipped_at).toLocaleString()}
            </Typography>
            {shipment.notes && (
              <Typography variant="body2" color="textSecondary">
                Notes: {shipment.notes}
              </Typography>
            )}
            <Typography variant="body2" mt={1}>
              Items Shipped:
            </Typography>
            {(shipment.items || []).map((item, index) => (
              <Typography key={`${item.product_id}-${item.variant_id}-${index}`} variant="body2">
                - {item.product_name} {item.variant_name && `(${item.variant_name})`}: 
                {item.quantity} pcs
              </Typography>
            ))}
          </Box>
        ))}
      </CardContent>
    </Card>
  );
};